import i18n from "../strings/i18n";
/**
 * Returns a function that takes a value and format function. Returns
 * unavailable string (using translate) if the value is undefined,
 * otherwise returns the output of the format function.
 */
var useFormatUndefined = function () {
    return function (value, formatFn) {
        if (value === undefined) {
            return i18n({ labels: "unavailable" });
        }
        return formatFn(value);
    };
};
export default useFormatUndefined;
//# sourceMappingURL=useFormatUndefined.js.map